import { render, staticRenderFns } from "./Block3Address.vue?vue&type=template&id=3d83a32e"
import script from "./Block3Address.vue?vue&type=script&lang=ts"
export * from "./Block3Address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports